var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import usePriceListProductByUuid from "@/react/Webshop/hooks/usePriceListProductByUuid";
import { useShoppingCart } from "@/react/Webshop/providers/ShoppingCartProvider";
import { callAPI } from "@/react/lib/common";
import { useState } from "react";
import { PRODUCT_RETOUCH_FILE_UUID } from "@/react/Webshop/providers/PriceListProvider";
const useRetouchPictures = (pictureUuids) => {
    const product = usePriceListProductByUuid(PRODUCT_RETOUCH_FILE_UUID);
    const [isUpdatingCart, setIsUpdatingCart] = useState(false);
    const { items } = useShoppingCart();
    const [picturesSubProducts, setPicturesSubProducts] = useState(getRetouchProducts(pictureUuids, items));
    const handleToggleSubProduct = (pictureUuid) => (subProduct) => {
        setPicturesSubProducts((picturesSubProducts) => {
            var _a;
            const current = (_a = picturesSubProducts[pictureUuid]) !== null && _a !== void 0 ? _a : [];
            let updated;
            if (current.includes(subProduct)) {
                updated = current.filter((sp) => sp !== subProduct);
            }
            else {
                updated = [...current, subProduct];
            }
            return Object.assign(Object.assign({}, picturesSubProducts), { [pictureUuid]: updated });
        });
    };
    const updateCart = () => __awaiter(void 0, void 0, void 0, function* () {
        setIsUpdatingCart(true);
        yield callAPI("/api/webshop/cart/retouch", "PUT", {
            items: picturesSubProducts,
        });
    });
    return {
        handleToggleSubProduct,
        product,
        picturesSubProducts,
        isUpdatingCart,
        updateCart,
    };
};
const getRetouchProducts = (pictureUuids, items) => {
    const retouchPictures = {};
    for (const pictureUuid of pictureUuids) {
        for (const item of items) {
            if (item.product.uuid !== PRODUCT_RETOUCH_FILE_UUID) {
                continue;
            }
            if (item.fileRetouch.file.uuid === pictureUuid) {
                console.log("Found item", item);
                retouchPictures[pictureUuid] = item.subProductUuids;
                break;
            }
        }
        if (typeof retouchPictures[pictureUuid] === "undefined") {
            retouchPictures[pictureUuid] = [];
        }
    }
    return retouchPictures;
};
export default useRetouchPictures;
